import React from "react";

interface RefreshSvgProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  flip?: "horizontal" | "vertical" | "both";
}

const RefreshSvg: React.FC<RefreshSvgProps> = ({
  width = 24,
  height = 24,
  color = "#2A2D31",
  flip,
}) => {
  let transform = "";
  if (flip === "horizontal") transform = "scaleX(-1)";
  else if (flip === "vertical") transform = "scaleY(-1)";
  else if (flip === "both") transform = "scaleX(-1) scaleY(-1)";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform }}
    >
      <path
        d="M14.6887 8.57029H19.2647L16.3488 5.65254C15.4101 4.71375 14.2407 4.03865 12.9583 3.69509C11.6759 3.35154 10.3256 3.35164 9.04324 3.69538C7.76088 4.03913 6.59161 4.71441 5.65298 5.65333C4.71434 6.59226 4.03943 7.76174 3.69608 9.0442M2.73724 18.0083V13.4323M2.73724 13.4323H7.31324M2.73724 13.4323L5.65224 16.35C6.59102 17.2888 7.76039 17.9639 9.0428 18.3075C10.3252 18.651 11.6755 18.6509 12.9578 18.3072C14.2402 17.9634 15.4095 17.2882 16.3481 16.3492C17.2867 15.4103 17.9616 14.2408 18.305 12.9584M19.2647 3.99429V8.56845"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshSvg;
